function InDebtedCoRoute() {
	window.location.href = "https://indebted.co"
	return null
}

export {InDebtedCoRoute}
